// The app's name as people see it: Ahillah, أَهِلَّةٌ, "new crescents", the plural of hilāl (Al-Baqarah 2:189). Where the name
// stands on its own (the welcome, the start-up screen, About, the page title, the installed app's name and a shared
// picture) the Arabic stands beside it, fully vowelled, so it is easy to recognise the first time. In sentences it
// is just Ahillah. Its address is ahillah.pages.dev; the app's first address now sends people here, with what they
// saved there (moved/, src/lib/move.ts).

export const APP_NAME = 'Ahillah';
/** The name in Arabic, fully vowelled, without the article and with tanwīn, as the owner writes it; set in Adwa as-Salaf. */
export const APP_NAME_AR = 'أَهِلَّةٌ';
/** Both, for plain text: the Arabic in Unicode isolates, so punctuation beside it keeps its place. */
export const APP_TITLE = `${APP_NAME} ⁨${APP_NAME_AR}⁩`;
